"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KLIP_CONNECT_BUTTON_ID = exports.KLIP_CTA_TEXT_ID = exports.KLIP_CLOSE_BUTTON_ID = exports.KLIP_MODAL_ID = exports.KLIP_STYLE_ID = exports.KLIP_WRAPPER_ID = exports.DEFAULT_BUTTON_COLOR = exports.ANIMATION_DURATION = exports.KLIP_HEADER_TEXT = void 0;
exports.KLIP_HEADER_TEXT = 'KLIP WALLET';
exports.ANIMATION_DURATION = 10;
exports.DEFAULT_BUTTON_COLOR = 'rgb(64, 153, 255)';
exports.KLIP_WRAPPER_ID = 'klip-wrapper';
exports.KLIP_STYLE_ID = 'klip-style-sheet';
exports.KLIP_MODAL_ID = 'klip-qrcode-modal';
exports.KLIP_CLOSE_BUTTON_ID = 'klip-qrcode-close';
exports.KLIP_CTA_TEXT_ID = 'klip-qrcode-text';
exports.KLIP_CONNECT_BUTTON_ID = 'klip-connect-button';
